import AccordionTabs from "a11y-accordion-tabs";

document.addEventListener("DOMContentLoaded", function () {
	new AccordionTabs(document.querySelector(".js-accordion-tabs"), {
		breakpoint: 800,
		tabsAllowed: true,
		startCollapsed: true
	});
});
